<template>
    <Container type="card-full" drankColor>
        <div v-if="list.length>0" class="main">
              <div style="margin-bottom:30px" v-if="+$store.getters.expertLoginUser.pexpertroletype === 1">
                <el-button style="height:50px;margin-left:20p;margin-top:20px" @click="countersignResult"
                  v-if="+project.projectstatus === 30?false:true"
                  :disabled="+project.projectstatus === 30?true:false"
                  type='primary'
                >提交会签结果</el-button>
                <span v-else style="color:red;margin-right:20px;">已会签</span>
                <el-button type='primary' style="height:50px;margin-left:20p;margin-top:20px" @click="printForm">
                  打印会签空表
                </el-button>
                <span @click="clickRefresh" style="color:blue;font-size:13px;cursor: pointer;">【点击刷新】</span>
              </div>
              <div id="countersignBOX">
                <div id="countersignResult">
                  <div class="countersignResult">
                    <div class="countersignResultHeader">
                        <div class="countersignResultHeader-item L-W">供应商</div>
                        <div class="countersignResultHeader-item">评审分</div>
                        <div class="countersignResultHeader-item">价格得分</div>
                        <div class="countersignResultHeader-item" v-if="+project.projectdoneflg === 5">履约得分</div>
                        <div class="countersignResultHeader-item">最终得分</div>
                        <div class="countersignResultHeader-item">排名</div>
                    </div>
                    <div class="countersignResultBody" v-for="item in list" :key="item.psid">
                        <div class="countersignResultHeader-item L-W">{{item.comfullname}}</div>
                        <div class="countersignResultHeader-item">{{item.pscommercialasexchange}}</div>
                        <div class="countersignResultHeader-item">{{item.psppriceasexchange}}</div>
                        <div class="countersignResultHeader-item" v-if="+project.projectdoneflg === 5">{{ item.psperformanceas}}</div>
                        <div class="countersignResultHeader-item">{{item.psas}}</div>
                        <div class="countersignResultHeader-item">{{item.psseq}}</div>
                    </div>
                  </div>
                </div>
                <div style="display:flex;margin-top:20px" v-if="myselfHQ">
                  <el-input
                    type="textarea"
                    style="width:500px"
                    :autosize="{ minRows: 3, maxRows: 5}"
                    placeholder="填写会签意见"
                    v-model="CountersigningOpinions"
                     :maxlength="1000" show-word-limit
                  >
                  </el-input>
                  <el-button type='primary' style="height:50px;margin-left:20px" @click="countersign">会签</el-button>
                </div>
                <div style="margin-top:20px;">
                    <div class="CountersigningView">
                        <div v-for="i in CView" class="infinite-list-item" :key="i.pexpertid">
                            <div class="C-item">{{i.pexpertsigndesc}}</div>
                            <div class="C-item" style="color:red;">{{i.pexpertname}} {{i.pexpertsignconfirmtime | newDate}}</div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:20px;" v-if="+this.$store.getters.expertLoginUser.pexpertroletype === 1">
                    <div class="file" v-if="appends.length === 0">
                      <div class="uploadbtn">
                        <upload-btn @changed='setfile' text="上传会签纸质扫描文件"></upload-btn>
                        <span style="color:red;">集中评审，请上传评审会签纸质文件和所有评审人身份证复印件，合成在一份文件中上传</span>
                      </div>
                      <div v-if="appendList.length" class="filelist">
                        <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                          <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                          </div>
                          <div class="btn" @click="delappend(item)"><span>删除</span></div>
                        </div>
                      </div>
                      <div class="uploadbtn"  v-if="appendList.length">
                        <el-button @click="saveFile" type='primary'>保存</el-button>
                      </div>
                    </div>
                    <div style="display:flex;" v-if="appends.length > 0">
                      <div>会签纸质扫描文件</div>
                      <div v-if="appends.length" class="filelist">
                        <div v-for="(item,index) in appends" :key="index" class="fileitem">
                          <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
        </div>
        <div v-else  class="main">
          <div @click="getAll" style="color:blue;font-size:13px;cursor: pointer;">【点击刷新】</div>
          集中评审，请上传评审会签纸质文件和所有评审人身份证复印件，合成在一份文件中上传。</div>
    </Container>
</template>
<script>
  import {getLodop} from '@/assets/js/LodopFuncs'
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import uploadBtn from '../../views/common/uploadBtn'
  import common from '@/mixin/common'
  import dayjs from 'dayjs'
  let LODOP

  export default {
    name: 'exMeetingSignIndex',
    components: {vggrid,uploadBtn},
    mixins: [common],
    data () {
      return {
        project: {},
        appendList:[],
        appends:[],
        list: [],
        pexpertInfo:{},
        btnLoading: false,
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          {field: 'comfullname', fieldtype: 'I', title: '供应商', calculExpr: ''},
          {field: 'psas', fieldtype: 'I', title: '最终得分', calculExpr: ''},
          {field: 'psseq', fieldtype: 'I', title: '排名', calculExpr: ''},
          {field: 'psdesc', fieldtype: 'I', title: '意见', calculExpr: ''}
        ],
        CountersigningOpinions:'',
        CView:[],
        allExpert:[],
        myselfHQ:true,

      }
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    created () {
      this.getModel()
    },
    async activated(){
      await this.getPageList()
      await this.getAllexpertList()
      await this.getMyselfHQ()
      await this.getPexertInfo()
      await this.getFile()
    },
    filters: {

      newDateTime (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd HH:mm:ss')
      },
      newDate(value){
        return dayjs(value).format('YYYY年MM月DD日 HH:mm:ss')
      },
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
      async getPageList () {
          this.loading = true
          let res = await request({
              method: 'get',
              url: 'expert/getMeetingList',
              params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
          })
          this.list = res

          this.loading = false
      },
      async saveFile(){
          this.loading = true
          this.$confirm(`保存后不可修改，是否保存`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(async () => {
            let res = await request({
                method: 'post',
                url: 'expert/saveFile',
                data: {projectid:this.$store.getters.expertLoginUser.pexpertprojectid,
                appends:this.appendList}
            })
            if(+res.issuccess === 1){
              await this.getFile()
              this.$message.success('上传成功')
            }
            }).catch(() => {
          })
          this.loading = false

      },
      async getFile(){
          this.loading = true
          this.appends = await request({
              method: 'get',
              url: 'expert/getAppend',
              params: {appendfromid:this.$store.getters.expertLoginUser.pexpertprojectid,
              appendfromtype:24}
          })
          this.loading = false

      },
      async getAll(){
        await this.getModel()
        await this.getPageList()
        await this.getAllexpertList()
        await this.getMyselfHQ()
        await this.getPexertInfo()
        await this.getFile()
      },
      async setfile (path, filename) {
        let res = {
          appendid: 0,
          appendfromid: this.$store.getters.expertLoginUser.pexpertprojectid,
          appendfromtype: '24',
          appendtype: '100',
          appendseq: this.appendList.length + 1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr, '')
        }
        if(this.appendList.length<1){
          this.appendList.push(res)
        }else{
          this.appendList.splice(0,1,res)
        }
      },
      async clickRefresh(){
        await this.getAllexpertList()
      },
      async countersign(){
        let res = ''
        this.$confirm(`是否提交会签结果`, '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
                res  = await request({
                    method: 'post',
                    url: 'expert/countersign',
                    data: {
                      pexpertid: this.$store.getters.expertLoginUser.pexpertid,
                      pexpertsigndesc:this.CountersigningOpinions,
                      projectid: this.$store.getters.expertLoginUser.pexpertprojectid
                    }
                })

                if(res.issuccess){
                  this.$message.success('评审完成，感谢您的专业付出，请退出评审工作台')
                  this.getMyselfHQ()
                  this.getAllexpertList()
                }
            }).catch(() => {

          })
      },
      async getMyselfHQ(){
          //获取自己的会签
          let res = await request({
              method: 'get',
              url: 'expert/getMyselfHQ',
              params: {pexpertid:this.$store.getters.expertLoginUser.pexpertid}
          })

          if(+res.pexpertsignstatus === 2){
            this.myselfHQ = false
          }
      },
      async countersignResult(){
          if(this.allExpert.length !== this.CView.length){
              this.$message.warning('评审人尚未会签，请等候或者催促评审人会签');
              return
          }
          let msg = ''
          if(this.appends.length === 0){
              msg="还未上传会签纸质扫描文件，是否继续提交"
          }else{
            msg="提交后不可修改，是否继续？"
          }
          this.loading = true
          this.$confirm(`${msg}`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {
                let model = {}
                model.list = this.list
                model.projectid = this.$store.getters.expertLoginUser.pexpertprojectid
                  let res = await request({
                      method: 'post',
                      url: 'expert/countersignResult',
                      data: model
                  })
                  if(res.issuccess === 1){
                    this.$message.success('评审完成，感谢您的专业付出，请退出评审工作台!')
                    await this.regNotice()
                    this.getModel()
                    return
                  }
              }).catch(() => {
          })
          this.loading = false
      },
      async regNotice(){
          let model = {}
          model.projectid = this.$store.getters.expertLoginUser.pexpertprojectid
          model.cosid = this.$store.getters.expertLoginUser.cosid

          await request({
              url: 'expert/countersignPush',
              method: "post",
              data: model
          })
      },
      async getAllexpertList(){
          this.loading = true
          let res = await request({
              method: 'get',
              url: 'expert/getAllexpertList',
              params: {
                pexpertprojectid: this.$store.getters.expertLoginUser.pexpertprojectid,
              }
          })
          this.allExpert = res
          this.CView = res.filter(e=>{
              return +e.pexpertsignstatus === 2
          })
          this.loading = false
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      },
      delappend (file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      async printForm () {
          let {href} = this.$router.resolve({name: 'projectMeetingP', query: {projectid: this.$store.getters.expertLoginUser.pexpertid}})
          window.open(href, '_blank')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
.main{
  font-size: 14px;
    color: #606266;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
}
.countersignResult{
  background-color: #fff;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #e8eaec;
  text-align: center;
}
.countersignResultHeader{
  background-color: #f8f8f9;
  display: flex;
  justify-content: center;
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #e8eaec;
}
.countersignResultHeader-item{
  flex:1;
  border-right: 1px solid #e8eaec;
}
.L-W{
  flex: 3;
}
.countersignResultHeader-item:last-child{
  border: none;
}
.countersignResultBody{
  display: flex;
  justify-content: center;
  line-height: 48px;
  border-bottom: 1px solid #e8eaec;
}
.countersignResultBody:last-child{
  border: none;
}
// .countersignResultHeader-item{
//   flex:1;
//   border-right: 1px solid #e8eaec;
// }
// .countersignResultHeader-item:last-child{
//   border: none;
// }




.CountersigningView{
    overflow: hidden;
    background: rgb(250, 252, 253);
    background-color: #fff;
}
.infinite-list-item{
  display: flex;
  width: 60%;
  margin: 10px 10px;
  // justify-content: center;
}
.C-item{
  margin-left: 20px;
  flex: 5;
}
.C-box{
  display: flex;
}
.el-scrollbar {
    height: 500px;
}
.el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
}
li{
  list-style: none;
}

.file {
  // display: flex;
  // width: 50%;
  .uploadbtn {
    display: flex;
    span {
      padding-left: 10px;
      color: red;
    }
  }
  .fileitem{
    width: 400px;
  }
}
</style>
